import { Typography } from '@mui/material';
import { BetslipTicketType, StakeErrorType } from '../../../../@types';
import { CurrencySymbol } from '../../../atoms/CurrencySymbol';
import { parseNumberWithDecimals, prepareStakeMessages } from '../../../../helpers';
import useLocalization from '../../../../hooks/useLocalization';
import { useGlobalTicketConditions } from '../../../../queries';
import { WalletType } from '../../../../types/enums';

const styles = {
  message: {
    display: 'block',
    color: 'neutral.300',
    typography: 'caption',
    fontWeight: 700,
    textAlign: 'right',
    lineHeight: 1.3,
  },
} as const;

type NeobetBetslipStakeMessageProps = {
  errorType?: StakeErrorType;
  ticketType: BetslipTicketType;
  selectedWallet: WalletType;
  testId?: string;
};

const NeobetBetslipStakeMessage = ({
  errorType,
  ticketType,
  selectedWallet,
  testId,
}: NeobetBetslipStakeMessageProps) => {
  const { t } = useLocalization();
  const { data: globalTicketConditions } = useGlobalTicketConditions();

  if (!errorType) {
    return null;
  }

  const stakeMessage = prepareStakeMessages(ticketType, selectedWallet, globalTicketConditions, errorType);

  if (!stakeMessage) {
    return null;
  }

  return (
    <Typography sx={styles.message} data-testid={testId}>
      {t(stakeMessage.type)} <CurrencySymbol />
      {stakeMessage.amount && parseNumberWithDecimals(stakeMessage.amount, 2)}
    </Typography>
  );
};

export default NeobetBetslipStakeMessage;
